var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { id: "se-tab-lcl-container" } },
    [
      _c(
        "cargo-up-down-resize",
        {
          staticClass: "main-content",
          staticStyle: { height: "100%" },
          attrs: {
            "up-style": {
              display: "flex",
              flexDirection: "column",
              paddingBottom: "5px"
            },
            "down-style": {
              display: "flex",
              flexDirection: "column",
              paddingTop: "5px"
            }
          }
        },
        [
          _c("template", { slot: "up" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isEdit,
                    expression: "isEdit"
                  }
                ],
                staticClass: "section"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { no: "1", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.pm.addSlaveHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "2", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.pm.removeSlaveHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section", staticStyle: { flex: "1" } },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", flex: "1" },
                  attrs: {
                    no: "3",
                    "config-module": "130116",
                    "grid-options": _vm.gridOptions,
                    "grid-params": _vm.gridParams,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.lclSlaves
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c("div", { staticStyle: { padding: "5px 0" } }, [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: { no: "5", type: "primary" },
                      on: { click: _vm.changeSealHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.SealNoChangeAdfterInspection"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      staticStyle: { color: "green" },
                      attrs: { no: "6", type: "info", plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.pm.addToContainerHandler()
                        }
                      }
                    },
                    [_vm._v("↓")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      staticStyle: { color: "red" },
                      attrs: { no: "7", type: "info", plain: "" },
                      on: {
                        click: function(p) {
                          _vm.pm.removeToContainerHandler()
                          _vm.changeLclSlaves()
                        }
                      }
                    },
                    [_vm._v("↑")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "55px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.totalLabel.package }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "11" },
                            model: {
                              value: _vm.slaveTotalDesc.slaveTotalQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.slaveTotalDesc,
                                  "slaveTotalQuantity",
                                  $$v
                                )
                              },
                              expression: "slaveTotalDesc.slaveTotalQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.TotalWeight") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "12" },
                            model: {
                              value: _vm.slaveTotalDesc.slaveTotalWeight,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.slaveTotalDesc,
                                  "slaveTotalWeight",
                                  $$v
                                )
                              },
                              expression: "slaveTotalDesc.slaveTotalWeight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.TotalCubage") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { no: "13" },
                            model: {
                              value: _vm.slaveTotalDesc.slaveTotalCubage,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.slaveTotalDesc,
                                  "slaveTotalCubage",
                                  $$v
                                )
                              },
                              expression: "slaveTotalDesc.slaveTotalCubage"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "template",
            { slot: "down" },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { height: "100%", "min-height": "300px" },
                  attrs: {
                    "left-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "20%"
                    },
                    "right-style": {
                      display: "flex",
                      flexDirection: "column",
                      width: "80%"
                    }
                  }
                },
                [
                  _c("template", { slot: "left" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { height: "100%" },
                          attrs: {
                            no: "14",
                            "config-module": "130117",
                            "grid-options": _vm.left.gridOptions,
                            "grid-params": _vm.left.gridParams,
                            "column-defs": _vm.containerColumnDefs,
                            "row-data": _vm.containers
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.left, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.left, "gridParams", $event)
                            },
                            gridReady: function(params) {
                              return (_vm.left.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("template", { slot: "right" }, [
                    _c(
                      "div",
                      { staticClass: "section", staticStyle: { flex: "1" } },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            no: "15",
                            "config-module": "130118",
                            "grid-options": _vm.right.gridOptions,
                            "grid-params": _vm.right.gridParams,
                            "column-defs": _vm.usageColumnDefs,
                            "row-data": _vm.selectedContainer.containerUsage
                          },
                          on: {
                            "update:gridParams": function($event) {
                              return _vm.$set(_vm.right, "gridParams", $event)
                            },
                            "update:grid-params": function($event) {
                              return _vm.$set(_vm.right, "gridParams", $event)
                            },
                            gridReady: function(params) {
                              return (_vm.right.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { padding: "5px 0" } }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.usagesTotalDesc.txtNum))])
                      ]),
                      _vm.jingyuWarehouse
                        ? _c("div", { staticClass: "lcl-dynamic-div" }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.jingyuWarehouse && !_vm.isEdit,
                                    expression: "jingyuWarehouse && !isEdit"
                                  }
                                ],
                                staticClass: "lcl-dynamic-span",
                                on: { click: _vm.showLclDynamicList }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("SeaExport.LclDynamic")) +
                                    " "
                                ),
                                _c("i", {
                                  class: _vm.jyLclDynamicDialog.visible
                                    ? "el-icon-caret-bottom"
                                    : "el-icon-caret-top"
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticStyle: { float: "right" } },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": "55px",
                                "label-position": "left"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.package }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "16" },
                                    model: {
                                      value:
                                        _vm.usagesTotalDesc.usageTotalQuantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usagesTotalDesc,
                                          "usageTotalQuantity",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usagesTotalDesc.usageTotalQuantity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.weight }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "17" },
                                    model: {
                                      value:
                                        _vm.usagesTotalDesc.usageTotalWeight,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usagesTotalDesc,
                                          "usageTotalWeight",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usagesTotalDesc.usageTotalWeight"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "custom",
                                  attrs: { label: _vm.totalLabel.cubage }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: { no: "18" },
                                    model: {
                                      value:
                                        _vm.usagesTotalDesc.usageTotalCubage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usagesTotalDesc,
                                          "usageTotalCubage",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "usagesTotalDesc.usageTotalCubage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _c("seal-number-change-dialog", {
        attrs: {
          visible: _vm.boxNoDialog.visible,
          "prop-form-data": _vm.selectedContainer
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.boxNoDialog, "visible", $event)
          },
          sealCloseHandler: _vm.sealCloseHandler
        }
      }),
      _c("query-se-lcl-dialog", {
        attrs: { visible: _vm.querySELclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.querySELclDialog, "visible", $event)
          },
          callback: function(rows) {
            _vm.pm.slaveAddedHandler(rows)
          }
        }
      }),
      _c("lcl-compare-harbour-dialog", {
        attrs: {
          visible: _vm.harbourDialog,
          "data-source": _vm.containers,
          "harbour-source": _vm.sourceList,
          job: _vm.job,
          "lcl-slave-so-no": _vm.lclSlaveSoNo,
          "hc-flag": _vm.hcFlag,
          "hq-flag": _vm.hqFlag,
          "container-height-flag": _vm.containerHeightFlag,
          "h-q-h-c-flag": _vm.HQHCFlag
        },
        on: {
          "update:visible": function($event) {
            _vm.harbourDialog = $event
          },
          addContainer: _vm.handleAddContainer
        }
      }),
      _c("box-Information-Verification", {
        attrs: {
          "dialog-visible": _vm.portareaDialogVisible,
          "content-show": _vm.contentShow,
          container: _vm.container
        },
        on: {
          "update:dialogVisible": function($event) {
            _vm.portareaDialogVisible = $event
          },
          "update:dialog-visible": function($event) {
            _vm.portareaDialogVisible = $event
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("FileHistory.Tips"),
            visible: _vm.dialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "portData-check" },
            [
              _c("i", { staticClass: "el-icon-error" }),
              _c("strong", [
                _vm._v(
                  "S/O NO" + _vm._s(_vm.$t("SeaExport.ItPortDataAndVerified"))
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("SeaExport.TheNotContainTheData")) + "S/O NO."
                )
              ]),
              _vm._l(_vm.checkSoNo, function(item) {
                return _c("p", { key: item }, [_vm._v(_vm._s(item))])
              })
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "19" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ]
      ),
      _c("xhq-send-container-dialog", {
        attrs: {
          "dialog-visible": _vm.xhqSendContainerDialog.visible,
          job: _vm.job,
          "container-usage": _vm.xhqSendContainerDialog.containerUsage,
          "selected-container": _vm.selectedContainer
        },
        on: {
          "update:dialogVisible": function($event) {
            return _vm.$set(_vm.xhqSendContainerDialog, "visible", $event)
          },
          "update:dialog-visible": function($event) {
            return _vm.$set(_vm.xhqSendContainerDialog, "visible", $event)
          }
        }
      }),
      _c("jy-release-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.containers,
          visible: _vm.jyReleaseDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyReleaseDialog, "visible", $event)
          }
        }
      }),
      _c("jy-take-container-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.jyTakeContainerDialog.containers,
          visible: _vm.jyTakeContainerDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyTakeContainerDialog, "visible", $event)
          }
        }
      }),
      _c("jy-container-preload-dialog", {
        attrs: {
          job: _vm.job,
          containers: _vm.jyContainerPreloadDialog.containers,
          visible: _vm.jyContainerPreloadDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyContainerPreloadDialog, "visible", $event)
          }
        }
      }),
      _c("jy-lcl-dynamic-dialog", {
        attrs: {
          "job-uuid": _vm.job.uuid,
          visible: _vm.jyLclDynamicDialog.visible
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jyLclDynamicDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }